import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare `/account/integrations/$appId` has no content of its own — redirect to the default Settings section.
export const Route = createFileRoute('/_app/account/integrations/$appId/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/account/integrations/$appId/settings', params: { appId: params.appId } })
  },
})
